import debug from 'debug'
import Config from '@/config'

const log = debug('mixin:ReCaptcha')

export default {
  data() {
    return {
      captchaResponse: null,
      action: '',
      useCaptcha: Config.get('useCaptcha'),
    }
  },
  computed: {
    isCaptchaValid() {
      return !!this.captchaResponse
    },
  },
  async mounted() {
    await this.init()
  },
  beforeDestroy() {
    this.$recaptcha.destroy()
  },
  methods: {
    async init() {
      await this.$recaptcha.init().catch((e) => {
        log(e)
      })
    },
    async recaptcha() {
      // await this.resetRecaptcha()
      const token = await this.$recaptcha.execute(this.action).catch((e) => {
        log('ReCaptcha err: ', e)
      })

      this.captchaResponse = token
    },
    async resetRecaptcha() {
      this.captchaResponse = null
      this.$recaptcha.destroy()
      await this.$recaptcha.init()
    },
  },
}
